/**
 * Who makes this, at the bottom of the app.
 *
 * Rendered once, under the main panel, on every screen except the immersive
 * drills — a countdown with a company attribution under it is noise at the one
 * moment the learner is trying to concentrate, and the drills already strip
 * the rail for the same reason.
 *
 * The link opens in a new tab, which is the standing rule here for anything
 * leaving the site: a learner mid-session should not lose the page they were
 * drilling on. `rel="noopener noreferrer"` goes with it, always — `_blank`
 * without `noopener` hands the new page a live handle on this one.
 */
export function Colophon() {
  return (
    <p className="colophon">
      A product of{' '}
      <a href="https://shorelineconsultingco.com" target="_blank" rel="noopener noreferrer">
        Shoreline Consulting
      </a>
      , copyright 2026. All rights reserved.
    </p>
  )
}
